<template>
  <div class="current-master__time-wrap">
    <input type="radio" name="time-radio" :id="'time-radio'+time_index">
    <label :for="'time-radio'+time_index" class="current-master__time" v-on:click="setTime">{{time_start}} - {{time_end}}</label>
  </div>
</template>
<script>
  import {mapMutations} from 'vuex'
export default {
    name: "OneMaster",
    props: {
        time_start: String,
        time_end: String,
        time_index: Number
    },
    methods: {
      ...mapMutations('client', ['setTime'])
    }
}
</script>
